export default __webpack_public_path__ + "static/media/notificationRain.1ccca834.mp3";